/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, Modal, Skeleton, Switch, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { menuRequest } from "../../../../menuRequest";
import {
  ModalStatusCreate,
  ModalStatusEdit,
} from "../../../../../../Utils/modalStatus";

const { Text } = Typography;

export const ModalInserir = ({
  visible,
  onCancel,
  id,
  estadoPermissao,
  idItem,
}) => {
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [openStatusModal, setOpenModalStatus] = useState({
    create: false,
    edit: false,
  });

  const [form] = Form.useForm();

  useEffect(() => {
    if (idItem) {
      detalhesMenu();
    }
  }, [idItem]);

  const inserirPermissao = async (data) => {
    setConfirmLoading(true);
    try {
      const response = await menuRequest.postMenuItem(data, idItem);
      if (response.status === 201) {
        onCancel();
        estadoPermissao((prevMenu) => [response.data, ...prevMenu]);
        form.resetFields();
        setOpenModalStatus((prevState) => ({ ...prevState, create: true }));
      }
      if (response.status === 200) {
        onCancel();
        const cb = (callback) => {
          if (callback.id === idItem) {
            return { ...callback, ...response.data };
          } else {
            return { ...callback };
          }
        };
        estadoPermissao((prevState) => prevState.map(cb));
        form.resetFields();
        setOpenModalStatus((prevState) => ({ ...prevState, edit: true }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setConfirmLoading(false);
    }
  };

  const detalhesMenu = async () => {
    setLoading(true);
    try {
      const response = await menuRequest.getMenuItemId(idItem);
      if (response.status === 200 || response.status === 201) {
        const { descricao, chave_rotina, menu_id, em_teste } = response.data;
        setLoading(false);
        form.setFieldsValue({
          ticket: response.data.ticket,
          descricao: descricao,
          chave_rotina: chave_rotina,
          menu_id: menu_id,
          em_teste: em_teste,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const descricao = Form.useWatch("descricao", form);

  const maxLength = 60;

  return (
    <>
      <Modal
        visible={visible}
        onCancel={() => {
          onCancel();
          form.resetFields();
        }}
        footer={null}
        title={id ? "Editar" : "Inserir"}
      >
        {loading ? (
          <Skeleton />
        ) : (
          <Form
            form={form}
            layout="vertical"
            style={{ fontWeight: "500" }}
            onFinish={() => {
              form
                .validateFields()
                .then((values) => inserirPermissao({ ...values, menu_id: id }));
            }}
          >
            <Form.Item
              name="ticket"
              label="Ticket:"
              rules={[{ required: true, whitespace: true, message: "Informe o ticket." }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="descricao"
              label="Descrição:"
              rules={[
                { required: true, message: "Este campo é obrigatório" },
                {
                  max: 60,
                  message:
                    "Certifique-se de que este campo não tenha mais de 60 caracteres.",
                },
              ]}
              style={{ marginBottom: 10 }}
            >
              <Input placeholder="Descrição" maxLength={60} />
            </Form.Item>
            {descricao?.length === 60 && (
              <Text type="danger">
                Você atingiu o limite máximo de {maxLength} caracteres.
              </Text>
            )}

            <Form.Item
              name="chave_rotina"
              label="Chave rotina:"
              rules={[
                { required: true, message: "Este campo é obrigatório" },
                {
                  validator: (_, value) => {
                    if (!value || /^CAD_|^ESP_|^REL_/.test(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "A chave rotina deve começar com CAD_, ESP_ ou REL_"
                      )
                    );
                  },
                },
              ]}
            >
              <Input placeholder="Chave rotina" maxLength={30} />
            </Form.Item>

            <Form.Item
              name="em_teste"
              label="Em teste:"
              valuePropName="checked"
            >
              <Switch
                style={{ marginTop: -20 }}
                checkedChildren={true}
                unCheckedChildren={false}
              />
            </Form.Item>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "40%",
                }}
              >
                <Button
                  onClick={() => {
                    onCancel();
                    form.resetFields();
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={confirmLoading}
                >
                  Confirmar
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Modal>

      <ModalStatusCreate
        onCancel={() =>
          setOpenModalStatus((prevState) => ({ ...prevState, create: false }))
        }
        visible={openStatusModal.create}
      />
      <ModalStatusEdit
        onCancel={() =>
          setOpenModalStatus((prevState) => ({ ...prevState, edit: false }))
        }
        visible={openStatusModal.edit}
      />
    </>
  );
};
